import { Card } from "@/app/admin/_common/ui/card";
import { formatUtcDateTime } from "@/app/_utils/dayjs";
import CuoEmpty from "@/app/admin/_common/CuoEmpty";
import type { FestivalRecentOrder } from "@/app/_services/FestivalService";
import { Receipt } from "lucide-react";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export default function FestivalRecentOrdersCard({ orders }: { orders: FestivalRecentOrder[] }) {
  return (
    <Card className="flex max-h-[280px] flex-col rounded-md p-4 shadow-none">
      <div className="mb-3 flex-none text-[13.5px] font-semibold text-foreground">Recent orders</div>
      {orders.length === 0 ? (
        <div className="flex flex-1 items-center justify-center">
          <CuoEmpty icon={Receipt} text="No orders yet" />
        </div>
      ) : (
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
          {orders.map((order) => (
            <div
              key={order.id}
              className="flex items-center justify-between gap-3 border-b border-border/50 py-2 last:border-0"
            >
              <div className="min-w-0">
                <div className="truncate text-[13px] text-foreground">
                  {order.guest_name || "Guest"}
                </div>
                <div className="truncate text-[11.5px] text-muted-foreground">
                  {order.show_title ?? "-"} · {formatUtcDateTime(order.created_at, "MMM D, YYYY h:mm a")}
                </div>
              </div>
              <div className="flex-none text-right">
                <div className="text-[13px] font-medium text-foreground">
                  {currencyFormat.format(order.total_price)}
                </div>
                <div className="text-[11.5px] text-muted-foreground">
                  {order.quantity} {order.quantity === 1 ? "ticket" : "tickets"}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
